export default "__VITE_ASSET__303b7303__"